import React, { JSX } from 'react';
import { IconName } from './types';
import classNames from 'classnames';

function Icon({ name, ...props }: { name: IconName; className?: string } & JSX.IntrinsicElements['span']) {
  return (
    <span {...props} className={classNames('material-symbols-sharp', props.className)}>
      {name}
    </span>
  );
}

export default Icon;
